<div [class.open]="isOpen" class="side-sheet fixed z-30   bg-[#333C46]  overflow-y-auto  p-7 "
  (appClickableDirective)="$event.stopPropagation()">
  <div class="h-full w-full flex flex-col">
    <div class="font-semibold text-white h-4 leading-[100%] text-base">{{modelName}}</div>
    <div class="mt-3  text-sm font-normal">Data Logger SN : {{dataLoggerSN}}</div>
    <div class="flex justify-center items-center mt-6 gap-3 ">
      <button
        class="h-[2.192rem] w-[4.38rem] rounded-full p-1.5 min-w-8 font-medium border-[2px] bg-[#35333c] border-[#79747E] border-solid flex justify-center items-center text-white/50 text-sm leading-5 tracking-normal"
        (click)="parameterSelected('load')"
        [ngClass]="{'buttonSelected':this.selectedTab==detailInfoType.LOAD}">Load</button>
      @if(selectedPlantType==plantType.SOLAR){
      <button
        class="h-[2.192rem] w-[4.38rem] rounded-full p-1.5 min-w-8 font-medium border-[2px] bg-[#35333c] border-[#79747E] border-solid flex justify-center items-center text-white/50 text-sm leading-5 tracking-normal"
        (click)="parameterSelected('solar')"
        [ngClass]="{'buttonSelected':this.selectedTab==detailInfoType.SOLAR}">Solar</button>}
      <button
        class="h-[2.192rem] w-[4.38rem] rounded-full p-1.5 min-w-8 font-medium border-[2px] bg-[#35333c] border-[#79747E] border-solid flex justify-center items-center text-white/50 text-sm leading-5 tracking-normal"
        (click)="parameterSelected('grid')" [class.order-3]="selectedPlantType === plantType.NON_SOLAR"
        [class.buttonSelected]="selectedTab === detailInfoType.GRID">Grid</button>
      <button
        class="h-[2.192rem] w-[4.38rem] rounded-full p-1.5 min-w-8 font-medium border-[2px] bg-[#35333c] border-[#79747E] border-solid flex justify-center items-center text-white/50 text-sm leading-5 tracking-normal"
        (click)="parameterSelected('battery')" [class.order-2]="selectedPlantType === plantType.NON_SOLAR"
        [class.buttonSelected]="selectedTab === detailInfoType.BATTERY">Battery</button>

    </div>
    <div class="font-semibold text-white text-base mt-5">Parameters</div>
    <div class="mt-5">
      @if (selectedTab === detailInfoType.LOAD ) {
      @if(inverterType===inverterTypeDetail.OPTIMUS_3P){
      @for(item of optimusInverterLoadTab;track item.key){
      <div class="flex justify-between   odd:bg-[#252A30]  even:bg-[#474D54] p-2">
        <span class="font-normal text-xs ">{{ item.label }}</span>
        <span class="font-semibold text-xs"> {{ (detailedInfo?.[item.key!] || '0') + item.unit }}</span>
      </div>
      }
      } @else if(inverterType===inverterTypeDetail.ARCTIC_HYBRID){
      @if (phaseType===1) {
      @for(item of arcticOnePhaseLoadTab;track item.key){
      <div class="flex justify-between   odd:bg-[#252A30]  even:bg-[#474D54] p-2">
        <span class="font-normal text-xs ">{{ item.label }}</span>
        <span class="font-semibold text-xs"> {{ (detailedInfo?.[item.key!] || '0') + item.unit }}</span>
      </div>
      }} @else {
      @for(item of arcticThreePhaseLoadTab;track item.key){
      <div class="flex justify-between   odd:bg-[#252A30]  even:bg-[#474D54] p-2">
        <span class="font-normal text-xs ">{{ item.label }}</span>
        <span class="font-semibold text-xs"> {{ (detailedInfo?.[item.key!] || '0') + item.unit }}</span>
      </div>
      }
      }
      }
      @else {
      @for (item of loadTab; track item.key) {
      <div class="flex justify-between   odd:bg-[#252A30]  even:bg-[#474D54] p-2">
        <span class="font-normal text-xs ">{{ item.label }}</span>
        <span class="font-semibold text-xs"> {{ (detailedInfo?.[item.key!] || '0') + item.unit }}</span>
      </div>
      }}
      }
      @else if (selectedTab === detailInfoType.SOLAR) {
      @if(inverterType===inverterTypeDetail.ARCTIC_HYBRID){
      @for (item of arcticSolarTab; track $index) {
      @if(item.label === 'Lifetime Solar Energy Generation') {
      <div class="flex justify-between odd:bg-[#252A30] even:bg-[#474D54] p-2">
        <span class="font-normal text-xs">{{ item.label }}</span>
        <span class="font-semibold text-xs">
          {{ detailedInfo?.[item.key!] || '0 kWh' }}
        </span>
      </div>
      }
      @else if(item.pvField) {
      <div class="flex justify-between odd:bg-[#252A30] even:bg-[#474D54] p-2">
        <span class="font-normal text-xs">{{ item.label }}</span>
        <span class="font-semibold text-xs">
          {{ (detailedInfo?.pvString?.[item.pvIndex!]?.[item.pvField!] || '0') + item.unit }}
        </span>
      </div>
      }
      @else {
      <div class="flex justify-between odd:bg-[#252A30] even:bg-[#474D54] p-2">
        <span class="font-normal text-xs">{{ item.label }}</span>
        <span class="font-semibold text-xs">
          {{ (detailedInfo?.[item.key!] || '0') + item.unit }}
        </span>
      </div>
      }


      }
      } @else {
      @for (item of solarTab; track item.key) {
      @if(item.label==='Lifetime Solar Energy Generation'){
      <div class="flex justify-between odd:bg-[#252A30]  even:bg-[#474D54] p-2">
        <span class="font-normal text-xs">{{ item.label }}</span>
        <span class="font-semibold text-xs"> {{ detailedInfo?.[item.key!] || '0 kWh' }}</span>

      </div>
      } @else {
      <div class="flex justify-between odd:bg-[#252A30]  even:bg-[#474D54] p-2">
        <span class="font-normal text-xs">{{ item.label }}</span>
        <span class="font-semibold text-xs"> {{ (detailedInfo?.[item.key!] || '0') + item.unit }}</span>
      </div>
      }
      }}
      } @else if (selectedTab === detailInfoType.GRID) {
      @if(inverterType===inverterTypeDetail.OPTIMUS_3P){
      @for(item of optimusInverterGridTab;track item.key){
      <div class="flex justify-between odd:bg-[#252A30]  even:bg-[#474D54] p-2">
        <span class="font-normal text-xs">{{ item.label }}</span>
        <span class="font-semibold text-xs"> {{ (detailedInfo?.[item.key!] || '0') + item.unit }}</span>
      </div>}
      } @else if (inverterType===inverterTypeDetail.ARCTIC_HYBRID) {
      @if (phaseType===1) {
      @for(item of arcticOnePhaseGridTab;track item.key){
      <div class="flex justify-between odd:bg-[#252A30]  even:bg-[#474D54] p-2">
        <span class="font-normal text-xs">{{ item.label }}</span>
        <span class="font-semibold text-xs"> {{ (detailedInfo?.[item.key!] || '0') + item.unit }}</span>
      </div>}} @else {
      @for(item of arcticThreePhaseGridTab;track item.key){
      <div class="flex justify-between odd:bg-[#252A30]  even:bg-[#474D54] p-2">
        <span class="font-normal text-xs">{{ item.label }}</span>
        <span class="font-semibold text-xs"> {{ (detailedInfo?.[item.key!] || '0') + item.unit }}</span>
      </div>}
      }
      }


      @else{
      @for (item of gridTab; track item.key) {
      <div class="flex justify-between odd:bg-[#252A30]  even:bg-[#474D54] p-2">
        <span class="font-normal text-xs">{{ item.label }}</span>
        <span class="font-semibold text-xs"> {{ (detailedInfo?.[item.key!] || '0') + item.unit }}</span>
      </div>
      }}
      }@else if (selectedTab === detailInfoType.BATTERY) {
      @if(inverterType===inverterTypeDetail.ARCTIC_HYBRID){
      @for(item of arcticBatteryTab;track $index){
      <div class="flex justify-between odd:bg-[#252A30]  even:bg-[#474D54] p-2">
        <span class="font-normal text-xs">{{ item.label }}</span>
        <span class="font-semibold text-xs"> {{ (detailedInfo?.[item.key!] || '0') + item.unit }}</span>
      </div>
      }
      } @else {
      @for(item of filteredBatteryTab;track $index){
      <div class="flex justify-between odd:bg-[#252A30]  even:bg-[#474D54] p-2">
        <span class="font-normal text-xs">{{ item.label }}</span>
        <span class="font-semibold text-xs"> {{ (detailedInfo?.[item.key!] || '0') + item.unit }}</span>
      </div>
      }}}
      <div class="mt-1.5 flex items-center  ml-1">
        <p><span class="text-center">
            &#42;</span>
          Values are approximate and may vary</p>
      </div>

    </div>
  </div>
</div>